import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`
      bg-[#141414] border border-[#333] relative overflow-hidden
      shadow-2xl backdrop-blur-sm
      ${className}
    `} data-id="element-173">
      {/* Subtle top highlight for depth */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#555] to-transparent opacity-50" data-id="element-174"></div>

      <div className={noPadding ? '' : 'p-6'} data-id="element-175">{children}</div>
    </div>;
}